module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_01-fda832f5399c366e30788f58f75f6826.jpg";